// ** Locale ES
import errorsCodes from './errorsCodes'

export const getTranslatedErrorMessage = (errorCode) => {
  const errorMessageObj = errorsCodes.find((error) => error.code === errorCode);

  return errorMessageObj?.translation || 'Ocurrió algún error.';
}
